export interface CountryRegions {
  value: string;
  name: {
    de: string;
    en: string;
  };
  regions: Region[];
}

export interface Region {
  value: string;
  name: {
    de: string;
    en: string;
  };
}

export const countries: CountryRegions[] = [
  {
    value: 'de',
    name: {
      de: 'Deutschland',
      en: 'Germany'
    },
    regions: [
      {
        value: 'baden-wuerttemberg',
        name: {
          de: 'Baden-Württemberg',
          en: 'Baden-Württemberg'
        }
      },
      {
        value: 'bayern',
        name: {
          de: 'Bayern',
          en: 'Bavaria'
        }
      },
      {
        value: 'berlin',
        name: {
          de: 'Berlin',
          en: 'Berlin'
        }
      },
      {
        value: 'brandenburg',
        name: {
          de: 'Brandenburg',
          en: 'Brandenburg'
        }
      },
      {
        value: 'bremen',
        name: {
          de: 'Bremen',
          en: 'Bremen'
        }
      },
      {
        value: 'hamburg',
        name: {
          de: 'Hamburg',
          en: 'Hamburg'
        }
      },
      {
        value: 'hessen',
        name: {
          de: 'Hessen',
          en: 'Hesse'
        }
      },
      {
        value: 'mecklenburg-vorpommern',
        name: {
          de: 'Mecklenburg-Vorpommern',
          en: 'Mecklenburg-Vorpommern'
        }
      },
      {
        value: 'niedersachsen',
        name: {
          de: 'Niedersachsen',
          en: 'Lower Saxony'
        }
      },
      {
        value: 'nordrhein-westfalen',
        name: {
          de: 'Nordrhein-Westfalen',
          en: 'North Rhine-Westphalia'
        }
      },
      {
        value: 'rheinland-pfalz',
        name: {
          de: 'Rheinland-Pfalz',
          en: 'Rhineland-Palatinate'
        }
      },
      {
        value: 'saarland',
        name: {
          de: 'Saarland',
          en: 'Saarland'
        }
      },
      {
        value: 'sachsen',
        name: {
          de: 'Sachsen',
          en: 'Saxony'
        }
      },
      {
        value: 'sachsen-anhalt',
        name: {
          de: 'Sachsen-Anhalt',
          en: 'Saxony-Anhalt'
        }
      },
      {
        value: 'schleswig-holstein',
        name: {
          de: 'Schleswig-Holstein',
          en: 'Schleswig-Holstein'
        }
      },
      {
        value: 'thueringen',
        name: {
          de: 'Thüringen',
          en: 'Thuringia'
        }
      }
    ]
  },
  {
    value: 'at',
    name: {
      de: 'Österreich',
      en: 'Austria'
    },
    regions: [
      {
        value: 'burgenland',
        name: {
          de: 'Burgenland',
          en: 'Burgenland'
        }
      },
      {
        value: 'kaernten',
        name: {
          de: 'Kärnten',
          en: 'Carinthia'
        }
      },
      {
        value: 'niederoesterreich',
        name: {
          de: 'Niederösterreich',
          en: 'Lower Austria'
        }
      },
      {
        value: 'oberoesterreich',
        name: {
          de: 'Oberösterreich',
          en: 'Upper Austria'
        }
      },
      {
        value: 'salzburg',
        name: {
          de: 'Salzburg',
          en: 'Salzburg'
        }
      },
      {
        value: 'steiermark',
        name: {
          de: 'Steiermark',
          en: 'Styria'
        }
      },
      {
        value: 'tirol',
        name: {
          de: 'Tirol',
          en: 'Tyrol'
        }
      },
      {
        value: 'vorarlberg',
        name: {
          de: 'Vorarlberg',
          en: 'Vorarlberg'
        }
      },
      {
        value: 'wien',
        name: {
          de: 'Wien',
          en: 'Vienna'
        }
      }
    ]
  },
  {
    value: 'ch',
    name: {
      de: 'Schweiz',
      en: 'Switzerland'
    },
    regions: [
      {
        value: 'aargau',
        name: {
          de: 'Aargau',
          en: 'Aargau'
        }
      },
      {
        value: 'appenzell-ausserrhoden',
        name: {
          de: 'Appenzell Ausserrhoden',
          en: 'Appenzell Outer Rhodes'
        }
      },
      {
        value: 'appenzell-innerrhoden',
        name: {
          de: 'Appenzell Innerrhoden',
          en: 'Appenzell Inner Rhodes'
        }
      },
      {
        value: 'basel-landschaft',
        name: {
          de: 'Basel-Landschaft',
          en: 'Basel-Landschaft'
        }
      },
      {
        value: 'basel-stadt',
        name: {
          de: 'Basel-Stadt',
          en: 'Basel-Stadt'
        }
      },
      {
        value: 'bern',
        name: {
          de: 'Bern',
          en: 'Bern'
        }
      },
      {
        value: 'fribourg',
        name: {
          de: 'Freiburg',
          en: 'Fribourg'
        }
      },
      {
        value: 'genf',
        name: {
          de: 'Genf',
          en: 'Geneva'
        }
      },
      {
        value: 'glarus',
        name: {
          de: 'Glarus',
          en: 'Glarus'
        }
      },
      {
        value: 'graubuenden',
        name: {
          de: 'Graubünden',
          en: 'Grisons'
        }
      },
      {
        value: 'jura',
        name: {
          de: 'Jura',
          en: 'Jura'
        }
      },
      {
        value: 'luzern',
        name: {
          de: 'Luzern',
          en: 'Lucerne'
        }
      },
      {
        value: 'neuenburg',
        name: {
          de: 'Neuenburg',
          en: 'Neuchâtel'
        }
      },
      {
        value: 'nidwalden',
        name: {
          de: 'Nidwalden',
          en: 'Nidwalden'
        }
      },
      {
        value: 'obwalden',
        name: {
          de: 'Obwalden',
          en: 'Obwalden'
        }
      },
      {
        value: 'schaffhausen',
        name: {
          de: 'Schaffhausen',
          en: 'Schaffhausen'
        }
      },
      {
        value: 'schwyz',
        name: {
          de: 'Schwyz',
          en: 'Schwyz'
        }
      },
      {
        value: 'solothurn',
        name: {
          de: 'Solothurn',
          en: 'Solothurn'
        }
      },
      {
        value: 'st-gallen',
        name: {
          de: 'St. Gallen',
          en: 'St. Gallen'
        }
      },
      {
        value: 'thurgau',
        name: {
          de: 'Thurgau',
          en: 'Thurgau'
        }
      },
      {
        value: 'tessin',
        name: {
          de: 'Tessin',
          en: 'Ticino'
        }
      },
      {
        value: 'uri',
        name: {
          de: 'Uri',
          en: 'Uri'
        }
      },
      {
        value: 'waadt',
        name: {
          de: 'Waadt',
          en: 'Vaud'
        }
      },
      {
        value: 'wallis',
        name: {
          de: 'Wallis',
          en: 'Valais'
        }
      },
      {
        value: 'zug',
        name: {
          de: 'Zug',
          en: 'Zug'
        }
      },
      {
        value: 'zuerich',
        name: {
          de: 'Zürich',
          en: 'Zurich'
        }
      }
    ]
  }
];

export const getCountryByValue = (value: string): CountryRegions | undefined => {
  return countries.find(country => country.value === value);
};
